import React from "react";
import CareerNav from "../../components/Navbar/CarrerNav";
import Footer from "../../components/Home/footer/Footer";
import { Helmet } from "react-helmet";
import {
  balance,
  community,
  graph,
  perks,
  security,
  support,
  wellness,
} from "../../Assets";

const Support = () => {
  return (
    <>
      <Helmet>
        <title>
          {" "}
          Avijobs Employee Benefits: Supporting Your Growth & Well-being
        </title>
        <meta
          name='discription'
          content=' Discover Avijobs comprehensive employee benefits, including health coverage, learning opportunities, and a supportive work environment to help you thrive.
'
        />
      </Helmet>
      <div className='App'>
        <CareerNav />
        <Header />
        <SupportData />
        <Footer />
      </div>
    </>
  );
};

const SupportData = () => {
  const data = [
    {
      id: 0,
      text: "gray-500",
      heading: "Health and Wellness",
      image: wellness,
      points: [
        {
          id: 0,
          heading: "Avijo Health Plans and Insurance: ",
          text: "We offer a range of health plans that cater to the diverse needs of our employees and their families. These plans include coverage for medical expenses, preventive care, and wellness programs, ensuring that you and your loved ones have access to quality healthcare.",
        },
        {
          id: 0,
          heading: "Mental Health Support:",
          text: "We provide access to mental health resources, including counseling services, to support your overall well-being and help you maintain a healthy work-life balance.",
        },
      ],
    },
    {
      id: 1,
      color: "#5D5D5D",
      heading: "Financial Security",
      image: security,
      points: [
        {
          id: 0,
          heading: "Retirement Plans:",
          text: "We offer competitive retirement savings plans to help you build a secure future. Our plans include company contributions to ensure that you’re on the right path toward financial stability.",
        },
        {
          id: 1,
          heading: "Income Protection:",
          text: "We provide income protection benefits, including disability insurance and life insurance, to safeguard you and your family against unexpected events.",
        },
        {
          id: 2,
          heading: "Performance Bonuses and Incentives:",
          text: "We reward hard work and dedication with performance-based bonuses and incentives, allowing you to share in the company’s success.",
        },
      ],
    },
    {
      id: 2,
      color: "#5D5D5D",
      heading: "Work-Life Balance",
      image: balance,
      points: [
        {
          id: 0,
          heading: "Flexible Work Hours:",
          text: "We understand that flexibility is key to balancing work and personal commitments. Our flexible work hours allow you to manage your time effectively, ensuring that you can meet your responsibilities both at home and at work.",
        },
        {
          id: 1,
          heading: "Remote Work Options:",
          text: "Depending on your role, we offer the opportunity to work remotely, giving you the freedom to work from a location that best suits your needs.",
        },
        {
          id: 2,
          heading: "Generous Leave Policy:",
          text: "Our leave policy includes ample vacation time, sick leave, and holidays. We also offer specialized leaves such as maternity and parental leave, ensuring you have the time you need for important life events.",
        },
      ],
    },
    {
      id: 3,
      color: "#5D5D5D",
      heading: "Perks and Allowances",
      image: perks,
      points: [
        {
          id: 0,
          heading: "Travel, Car, and House Allowances:",
          text: "We offer allowances for travel, car, and housing to help ease the financial burden and make life outside of work more enjoyable.",
        },
        {
          id: 1,
          heading: "Professional Development:",
          text: "We encourage continuous learning and offer funding for professional development courses, certifications, and training to help you grow in your career.",
        },
        {
          id: 2,
          heading: "Discounts:",
          text: "Enjoy exclusive discounts on Avijo products and services, including healthcare services, which provide additional value to you and your family.",
        },
      ],
    },
    {
      id: 4,

      heading: "Support and Engagement",
      image: support,
      points: [
        {
          id: 0,
          heading: "KYC (Know Your Colleague) Program:",
          text: "Our unique KYC program helps new employees connect with colleagues from day one, fostering a sense of community and belonging. This program is designed to make your transition into the company smooth and enjoyable, ensuring you feel at home from the start.",
        },
        {
          id: 1,
          heading: "Wellness Programs:",
          text: "Participate in wellness programs and initiatives designed to keep you healthy and happy. These include fitness challenges, health screenings, and workshops focused on maintaining a balanced lifestyle.",
        },
      ],
    },
    {
      id: 5,
      color: "#5D5D5D",
      heading: "Culture and Community",
      image: community,
      points: [
        {
          id: 0,
          heading: "Inclusive and Diverse Workplace:",
          text: "We are committed to building a workplace where diversity is celebrated, and everyone feels included. Our policies and programs are designed to create an environment where all employees can thrive.",
        },
        {
          id: 1,
          heading: "Recognition:",
          text: "We believe in recognizing and celebrating the achievements of our team members. Our employee recognition programs highlight the contributions of those who go above and beyond in their roles.",
        },
        {
          id: 2,
          heading: "Social Events and Activities:",
          text: "Engage in various social events, team-building activities, and community service initiatives that foster camaraderie and a strong team spirit.",
        },
      ],
    },
  ];

  return (
    <>
      <div className='p-8 pt-0'>
        {data.map((item, index) =>
          index % 2 === 0 ? (
            index % 2 === 0 && (
              <div
                key={index}
                className='flex items-center justify-between border-b-2 p-8 md:flex-row'
              >
                <div className='flex h-full w-[50%] flex-col p-2 pt-0'>
                  <div className='flex-grow'>
                    <h3 className='text-4xl text-gray-500'>{item.heading}</h3>
                    <ul className='list-disc pl-5'>
                      {item.points.map((point, idx) => (
                        <li key={idx} className='text-l mt-2'>
                          <h6 className='font-semibold'>{point.heading}</h6>
                          <p>{point.text}</p>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className='ml-20 w-[50%] p-4 pb-0 pt-0'>
                  <img
                    src={item.image}
                    alt={item.heading}
                    loading='lazy'
                    className='w-100 rounded-2 h-80'
                  />
                </div>
              </div>
            )
          ) : (
            <div
              key={index}
              className='flex w-[100%] items-center justify-between border-b-2 p-8 md:flex-row'
            >
              <div className='mr-20 w-[50%] p-4 pb-0'>
                <img
                  src={item.image}
                  alt={item.heading}
                  className='w-100 rounded-2 h-80'
                />
              </div>
              <div className='flex h-full w-[50%] flex-col p-2'>
                <div className='flex-grow'>
                  <h3 className='text-4xl text-gray-500'>{item.heading}</h3>
                  <ul className='list-disc pl-5'>
                    {item.points.map((point, idx) => (
                      <li key={idx} className='text-l mt-2'>
                        <h6 className='font-semibold'>{point.heading}</h6>
                        <p>{point.text}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )
        )}{" "}
      </div>
    </>
  );
};

const Header = () => (
  <header className='hero bg-white'>
    <div className='p-8 pt-0'>
      <div class='flex justify-between p-8 pb-0 md:flex-row'>
        <div className='flex h-full w-[100%] flex-col'>
          <div className='flex-grow'>
            <span className='pb-[10px] text-[1.2rem]'>
              <p
                className='pb-[4rem] pt-[1rem]'
                style={{ fontFamily: "Gilroy-SemiBold" }}
              >
                Our benefits are designed to support the well-being of our
                colleagues and their families. We offer various Avijo health
                plans/insurance for colleague and eligible family members,
                financial security options, flexible work hours, and a generous
                leave policy that includes maternity and parental leave.
                Additionally, we provide travel, car, and house allowances to
                help our team members feel secure and supported in all aspects
                of their lives
              </p>
            </span>
            <h3
              className='pb-[1rem] text-4xl'
              style={{ fontFamily: "Gilroy-SemiBold" }}
            >
              Supporting Your Well-Being and Growth!
            </h3>
            <span className='mb-[0%] font-sans text-[1.2rem]'>
              <p className='w-[85%]'>
                We believe that taking care of our colleague is paramount to
                building a successful and thriving organization. We offer a
                comprehensive benefits package designed to support your
                well-being, financial security, and professional growth,
                ensuring that you have the resources and flexibility needed to
                succeed in both your personal and professional life.
              </p>
            </span>
          </div>
        </div>
        <div className='h-80 w-[80%]'>
          <img src={graph} alt='graph' className='h-screen w-screen' />
        </div>
      </div>
    </div>
  </header>
);

export default Support;
